module.exports = __webpack_public_path__ + "img/11.ccf65c05.png";